import { Button, message, Statistic, Table } from 'antd';
import React, { useEffect, useState } from 'react';
import NumberFormat from 'react-number-format';
import { Link } from 'react-router-dom';
import { ApproveInfluecner } from '../../../apis/Admin/Influencers/ApproveInfluecner';
import { GetPendingInfluencers } from '../../../apis/Admin/Influencers/GetPendingInfluencers';
import { useGlobalState } from '../../../store/state';
import { numberToShortFormat } from '../../../utils';
import CurrencyIcon from '../../Common/CurrencyIcon';
import './HomeTabledComponents.styles.scss';

const InfluencerApprovalsComponent = ({ className }) => {
  const [user] = useGlobalState('user');
  const [infList, setInfList]= useState({
    totalPending: 0,
    data: [],
  });

  const getPendingApprovals = () =>{
    GetPendingInfluencers(user.accessToken, 0, 7).then(({ status, response })=>{
      console.log('sdf', response);
      if (status === 200) {
        setInfList({
          ...infList,
          totalPending: response.totalDocs || 0,
          // data:response.influencers || []
          data: response.influencers.map((inf)=>{
            return {
              key: inf.id || 'n/a',
              name: inf.firstname +' '+inf.lastname,
              handle: inf.handle,
              premium: inf.is_premium,
              avatar: inf.picture,
              followers: inf.followers || 'n/a',
              er: inf.avgEarning || 'n/a',
            };
          }),
        });
      } else {
        console.log('Failed to fetch Influencers List', response);
      }
    });
  };

  useEffect(()=>{
    getPendingApprovals();
  }, []);

  const approval = (id) =>{
    // alert(id)
    ApproveInfluecner(user.accessToken, id).then(({ status, response })=>{
      console.log('approval influcners', response);
      if (status === 200) {
        message.success('Influencer Approved Successfully!');
        getPendingApprovals();
      } else {
        message.error('There is some issue while Approving influencer');
      }
    });
  };

  // const dataSource = [
  //     {
  //       key: '1',
  //       name: 'Joe Doe',
  //       handle:"@joedoe",
  //       avatar:'/images/avatar.png',
  //       followers: 15000,
  //       er: "1.1%",
  //     },
  //     {
  //       key: '2',
  //       name: 'Duran Clayton',
  //       handle:"@durangros",
  //       avatar:'/images/avatar.png',
  //       followers: 7520,
  //       er: "0.8%",
  //     },
  //     {
  //       key: '3',
  //       name: 'Dravid Rahul',
  //       handle:"@drrh",
  //       avatar:'/images/avatar.png',
  //       followers: 115000,
  //       er: "3.1%",
  //     },
  //     {
  //       key: '4',
  //       name: 'Duran Clayton',
  //       handle:"@durangros",
  //       avatar:'/images/avatar.png',
  //       followers: 7520,
  //       er: "0.8%",
  //     },
  //     {
  //       key: '5',
  //       name: 'gapsio',
  //       handle:"@gapsio",
  //       avatar:'/images/avatar.png',
  //       followers: 1020,
  //       er: "1.7%",
  //     },
  //     {
  //       key: '6',
  //       name: 'Gasxn Max',
  //       handle:"@gaxs",
  //       avatar:'/images/avatar.png',
  //       followers: 40500,
  //       er: "1.1%",
  //     },
  //     {
  //       key: '7',
  //       name: 'Maxiis',
  //       handle:"@maxis",
  //       avatar:'/images/avatar.png',
  //       followers: 65820,
  //       er: "2.1%",
  //     },
  //   ];

  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      render: (value, rest) => (
        <div className="table_name_field">{value}<span>{rest.handle}</span></div>
      ),
    },
    {
      width: 90,
      // align:"right",
      title: 'Followers',
      dataIndex: 'followers',
      key: 'followers',
      sorter: (a, b) => a.followers - b.followers,
      render: (value) => numberToShortFormat(value),

    },
    {
      width: 110,
      // align:"right",
      title: 'Eng. Rates',
      dataIndex: 'er',
      key: 'er',
      sorter: (a, b) => a.er.split('%')[0] - b.er.split('%')[0],
    },
    {
      width: 85,
      title: 'Action',
      align: 'right',
      dataIndex: 'action',
      key: 'action',
      render: (value, rest) =>(
        <button
          className="common_button outlined small my-1 d-inline-block py-1"
          onClick={() => approval(rest.key)}
        >Accept</button>
      ),
    },
  ];

  return (
    <div className={`${className}`}>
      <div className="common_card admin_stats_tabled p-3 h-100">
        <div className="admin_stats_tabled_top d-md-flex d-flex-wrap">
          <div className="col-md-7 p-0">
            <h4 className="mb-0">Influencer Approvals</h4>
            <p className="m-0">{infList.totalPending} New Influencer Sign ups</p>
          </div>
          <div className="col-md-5 text-right p-0">
            <Link to="/admin/dashboard/influencers?status=pending"
              className="common_button">View All</Link>
          </div>
        </div>
        <div className="admin_stats_tabled_data pt-4">
          <Table className="tiny_table"
            dataSource={infList.data}
            columns={columns}
            pagination={false} />
        </div>
      </div>
    </div>
  );
};

export default InfluencerApprovalsComponent;
